import { 
	DECISIONS_SEARCH_FOR_OPTION, 
	FILINGS_SEARCH_FOR_OPTION, 
	RAIL_RECORDATIONS_SEARCH_FOR_OPTION, 
	WATER_RECORDATIONS_SEARCH_FOR_OPTION, 
	ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION,
	ALL_DOCUMENTS_SEARCH_FOR_OPTION
} from "./searches";
import { ASSOCIATED_TAB_LABEL } from "./ui";
import React from "react";

export const DATA_TYPE_FIELD = "dataType";

export const FORMAL_FILING_FORM_TYPE = "formal";
export const OTHER_FILING_FORM_TYPE = "other";
export const RECORDATION_FORM_TYPE = "recordation";
export const RCPA_FORM_TYPE = "rcpa";
export const ENVIRONMENTAL_COMMENTS_FORM_TYPE = 'environmentalComment';

export const COMPLEX_SEARCH_LABEL = "Complex Search: ";
export const COMPLEX_SEARCH_NAME = "complexSearch";
export const DOCKET_NUM_LABEL = "Docket Number: ";
export const DOCKET_NUM_HEADER = "Docket Number";
export const DOCKET_NUM_FIELD = "docketNum";
export const DOCKET_NUM_PART_ONE_NAME = "docketNum_one";
export const DOCKET_NUM_PART_TWO_NAME = "docketNum_two";
export const DOCKET_NUM_PART_THREE_NAME = "docketNum_three";
export const DOCKET_NUM_PART_FOUR_NAME = "docketNum_four";
export const DOCKET_TITLE_LABEL = "Docket Title: ";
export const DOCKET_TITLE_HEADER = "Docket Title";
export const DOCKET_TITLE_FIELD = "docketTitle";
export const DOCKET_TITLE_NAME = "docketTitle";
export const DOCKETS_LABEL = "Dockets";

export const SERVICE_LIST_HEADER = "Service List";
export const SERVICE_LIST_FIELD = "serviceList";
export const SERVICE_LIST_TEXT = "Generate Service List";

export const OFFICIAL_FILING_DATE_LABEL = "Official Filing Date:";
export const OFFICIAL_FILING_DATE_HEADER = "Official Filing Date";
export const OFFICIAL_FILING_DATE_FIELD = "officialFilingDate";
export const OFFICIAL_FILING_DATE_START_LABEL = "Start: ";
export const OFFICIAL_FILING_DATE_START_NAME = "officialFilingStartDate";
export const OFFICIAL_FILING_DATE_END_LABEL = "End: ";
export const OFFICIAL_FILING_DATE_END_NAME = "officialFilingEndDate";
export const SERVICE_DATE_LABEL = "Service Date:";
export const SERVICE_DATE_HEADER = "Service Date";
export const SERVICE_DATE_FIELD = "serviceDate";
export const SERVICE_DATE_START_LABEL = "Start: ";
export const SERVICE_DATE_START_NAME = "serviceStartDate";
export const SERVICE_DATE_END_LABEL = "End: ";
export const SERVICE_DATE_END_NAME = "serviceEndDate";
export const DATE_RANGE_LABEL = "Date:";
export const DATE_RANGE_FROM_LABEL = "From:";
export const DATE_RANGE_TO_LABEL = "To:";
export const DECISION_TYPE_LABEL = "Decision Type: ";
export const DECISION_TYPE_HEADER = "Decision Type";
export const DECISION_TYPE_FIELD = "decisionType";
export const DECISION_TYPE_NAME = "decisionType";
export const DECISION_ID_LABEL = "Decision ID: ";
export const DECISION_ID_HEADER = "Decision ID";
export const DECISION_ID_FIELD = "decisionNumber";/* changed from decisionId */
export const DECISION_ID_NAME = "decisionNumber";/* changed from decisionId */
export const DECIDING_BODY_LABEL = "Deciding Body: ";
export const DECIDING_BODY_HEADER = "Deciding Body";
export const DECIDING_BODY_FIELD = "decidingBody";
export const DECIDING_BODY_NAME = "decidingBody";
export const DECISION_SUMMARY_LABEL = "Decision Summary: ";
export const DECISION_SUMMARY_HEADER = "Decision Summary";
export const DECISION_SUMMARY_NAME = "decisionSummary";
export const DECISION_SUMMARY_FIELD = "decisionSummary";
export const DECISION_ATTACHMENT_HEADER = "Attachment";
export const DECISION_ATTACHMENT_FIELD = "decisionAttachment";

export const FILING_DATE_LABEL = "Filing Date: ";
export const FILING_DATE_HEADER = "Official Filing Date";
export const FILING_DATE_FIELD = "filingDate";
export const FILING_DATE_START_LABEL = "Start: ";
export const FILING_DATE_START_NAME = "filingStartDate";
export const FILING_DATE_END_LABEL = "End: ";
export const FILING_DATE_END_NAME = "filingEndDate";
export const FILING_TYPE_LABEL = "Filing Type: ";
export const FILING_TYPE_HEADER = "Filing Type";
export const FILING_TYPE_FIELD = "filingType";
export const FILING_TYPE_NAME = "filingType";

//FILING FORM
export const FILED_FOR_LABEL = "Filed For: ";
export const FILED_FOR_HEADER = "Filed For";
export const FILED_FOR_FIELD = "filedFor";
export const FILED_FOR_NAME = "filedFor";
export const FILING_ID_LABEL = "Filing ID: ";
export const FILING_ID_HEADER = "Filing ID";
export const FILING_ID_FIELD = "filingName";/* changed from filingId */
export const FILING_ID_NAME = "filingName";/* changed from filingId */
export const FILING_ATTACHMENT_HEADER = "Attachment";
export const FILING_ATTACHMENT_FIELD = "filingAttachment";

export const RECORDATION_CATEGORY_LABEL = "Category: ";
export const RECORDATION_CATEGORY_FIELD = "recordationCategory";
export const RECORDATION_NO_LABEL = "Recordation No: ";
export const RECORDATION_NO_HEADER = <span style={{whiteSpace: "nowrap"}}>Recordation #</span>;
export const RECORDATION_NUMBER_LABEL = "Recordation Number: "; 
export const RECORDATION_NUM_FIELD = "recordationNumber";
export const RECORDATION_NO_NAME = "recordationNo";
export const RECORDATION_SUFFIX_LABEL = "Suffix: ";
export const RECORDATION_SUFFIX_NAME = "recordationSuffix";
export const RECORDATION_PARTY_LABEL = "Party: ";
export const RECORDATION_PARTY_HEADER = "Party";
export const RECORDATION_PARTY_FIELD = "party";
export const RECORDATION_PARTY_NAME = "party";
export const RECORDATION_PARTY_ID_FIELD = "partyId";
export const RECORDATION_TYPE_OF_AGREEMENT_LABEL = "Type of Agreement: ";
export const RECORDATION_TYPE_OF_AGREEMENT_HEADER = "Type of Agreement";
export const RECORDATION_TYPE_OF_AGREEMENT_FIELD = "typeOfAgreement";
export const RECORDATION_TYPE_OF_AGREEMENT_NAME = "typeOfAgreement";
export const RECORDATION_TYPE_FIELD = "recordationType";
export const RECORDATION_TYPE_HEADER = "Recordation Type";
export const RECORDATION_TYPE_LABEL = "Type of Agreement: ";
export const RECORDATION_HAC_HEADER = "HAC?";
export const RECORDATION_HAC_LABEL = 'Have parties identified a "hereafter acquired" clause (HAC)?';
export const RECORDATION_HAC_FIELD = "hac";
export const RECORDATION_EQUIPMENT_DESCRIPTION_LABEL = 'Equipment Description: ';
export const RECORDATION_EQUIPMENT_DESCRIPTION_HEADER = 'Equipment Description';
export const RECORDATION_EQUIPMENT_DESCRIPTION_FIELD = 'equipmentDescription';
export const RECORDATION_EQUIPMENT_DESCRIPTION_NAME = 'equipmentDescription';
export const RECORDATION_CROSS_REFERENCE_NUMBERS = 'crossReferenceNumbers';
export const RECORDATION_CROSS_REFERENCE_IDS = 'crossReferenceIds';
export const RECORDATION_CROSS_REFERENCE_HEADER = 'Cross References';
export const DOCUMENT_ID_FIELD = "documentId";
export const DOCUMENT_NAME_FIELD = "documentName";
export const RECORDATION_ATTACHMENT_FIELD = "recordationAttachment";

export const PARTY_TYPE_HEADER = 'Party Type';
export const PARTY_TYPE_LABEL = 'Party Type: ';
export const PARTY_TYPE_FIELD = 'partyType';
export const OTHER_PARTY_TYPE_LABEL = 'Other:';
export const OTHER_PARTY_TYPE_FIELD = 'otherPartyType';
export const ADDRESS_LINE_1_FIELD = "addressLine1";
export const ADDRESS_LINE_2_FIELD = "addressLine2";
export const PARTIES_LABEL = 'Parties';
export const FILED_BY_HEADER = 'Filed By';
export const FILED_BY_FIELD = 'filedBy';
export const FILED_BY_LABEL = 'Filed By:'
export const FILED_BY_LABEL_END = '(i.e. the individual who signed document)'
export const ADDRESS_HEADER = 'Address';
export const ADDRESS_FIELD = 'address';
export const ADDRESS_LINE_ONE_FIELD = 'addressLineOne';
export const ADDRESS_LINE_TWO_FIELD = 'addressLineTwo';
export const ADDRESS_CITY_FIELD = 'addressCity';
export const ADDRESS_COUNTRY_FIELD = 'addressCountry';
export const ADDRESS_STATE_FIELD = 'addressState';
export const ADDRESS_ZIP_FIELD = 'addressZip';
export const ADDRESS_TEL_FIELD = 'addressTel';
export const ADDRESS_FAX_FIELD = 'addressFax';
export const EMAIL_HEADER = 'Email';
export const EMAIL_FIELD = 'email';
export const EMAILS_LABEL = 'Email Address:';
export const EMAILS_TEXT = 'Email Address';
export const ADDITIONAL_EMAIL_FIELD = 'additionalEmails';
export const ADDITIONAL_EMAIL_LABEL = 'Additional email address(es) to be used for E-Service communication';

export const PRIMARY_OR_SECONDARY_LABEL = 'Is this a Primary Recordation or is it a Secondary Recordation?';
export const PRIMARY_RECORDATION_NUM_FIELD = "primaryRecordationNumber";
export const PRIMARY_RECORDATION_NUM_LABEL = 'What is the Primary Recordation # associated with this recordation?';
export const SUBMITTER_FIELD = "submitter";
export const SUBMITTER_LABEL = "Submitter:";
export const SUBMITTER_HEADER = "Submitter";
export const REC_COMPANY_FIELD = "company";
export const REC_COMPANY_LABEL = "Company Name:";
export const RECORDATION_DATE_OF_AGREEMENT_LABEL = "Date of Agreement:";
export const RECORDATION_DATE_OF_AGREEMENT_FIELD = "dateOfAgreement";
export const RECORDATION_DOCUMENT_DATE_LABEL = "Document Date: ";
export const RECORDATION_DOCUMENT_LABEL = "Document: ";
export const DOCUMENT_TYPE_FIELD = "documentType";
export const DOCUMENT_TYPE_LABEL = "Type of Agreement: (equipment trust, mortgage, assignment, etc.)";
export const EQUIPMENT_DESCRIPTION_FIELD = "equipmentDescription";
export const EQUIPMENT_DESCRIPTION_LABEL = "Equipment Description:";
export const HAC_FIELD = "hasHac";
export const HAC_LABEL = 'Have parties identified a "hereafter acquired" clause (HAC)?';
export const HAC_OPTIONS = [
	{ label: "Yes", value: "true" },
	{ label: "No", value: "false" }
];

//ENVIRONMENTAL COMMENTS
export const ENVCOM_HAVE_DOCKETS_LABEL = "Do you know the related docket number(s) for this environmental comment?";
export const ENVCOM_HAVE_DOCKETS_FIELD = "haveDocketNumbers";
export const ENVCOM_PROJECT_FIELD = "project";
export const ENVCOM_PROJECT_LABEL = "Project Name and/or Location:";
export const ENVCOM_PROJECT_HEADER = "Project Name and/or Location";
export const ENVCOM_LOCATION_FIELD = "location";
export const ENVCOM_LOCATION_HEADER = "Location";
export const ENVCOM_ATTENTION_FIELD = "attention";
export const ENVCOM_ATTENTION_LABEL = "Attention of:";
export const ENVCOM_ATTENTION_HEADER = "Attention of";
export const ENVCOM_YOUR_NAME_FIELD = "name";
export const ENVCOM_YOUR_NAME_LABEL = "Submitter:";
export const ENVCOM_YOUR_NAME_HEADER = "Your Name";
export const ENVCOM_ORGANIZATION_FIELD = "organization";
export const ENVCOM_ORGANIZATION_LABEL = "Organization (if applicable):";
export const ENVCOM_ORGANIZATION_HEADER = "Organization";
export const ENVCOM_AFFILIATION_FIELD = "affiliation";
export const ENVCOM_AFFILIATION_LABEL = "Affiliation:";
export const ENVCOM_AFFILIATION_HEADER = "Affiliation";
export const ENVCOM_ORGANIZATION_FORM_LABEL = "Organization:";
export const ENVCOM_SUBMITTER_OR_RECIPIENT_HEADER = "Submitter or Recipient";
export const ENVCOM_SUBMITTER_OR_RECIPIENT_LABEL = "Submitter or Recipient:";
export const ENVCOM_SUBMITTER_OR_RECIPIENT_FIELD = "submitterRecipient";
export const ENVCOM_SUBMITTER_FIELD = "submitter";
export const ENVCOM_RECIPIENT_FIELD = "letterRecipient";
export const ENVCOM_DATE_RECEIVED_FIELD = "eiDateReceived";
export const ENVCOM_DATE_OF_LETTER_FIELD = "eoDateOfLetter";
export const ENVCOM_COMMENTS_FIELD = "comments";
export const ENVCOM_COMMENTS_LABEL = "Environmental Comments:";
export const ENVCOM_COMMENTS_HEADER = "Environmental Comments";
export const ENVCOM_TYPE_LABEL = "Type:";
export const ENVCOM_TYPE_FIELD = "enviroCommentType";
export const ENVCOM_TYPE_ID_FIELD = "enviroCommentTypeId";
export const ENVCOM_ID_FIELD = "enviroCommentNumber";
export const ENVCOM_ID_LABEL= "Comment ID:";
export const ENVCOM_ID_HEADER = "Comment ID";
export const ENVCOM_DATE_FIELD = "date";
export const ENVCOM_DATE_HEADER = "Date Received or Sent";
export const ENVCOM_DATE_RANGE_LABEL = "Date Received or Sent:";
export const ENVCOM_DATE_START_NAME = "startDate";
export const ENVCOM_DATE_START_LABEL = "Start:";
export const ENVCOM_DATE_END_NAME = "endDate";
export const ENVCOM_DATE_END_LABEL = "End:";
export const ENVCOM_ATTACHMENT_FIELD = "enviroCommentAttachment";
export const ENVCOM_ATTACHMENT_HEADER = "Attachment";

// All Documents Search
export const ALL_DOOCUMENTS_DATE_HEADER = "Date";
export const ALL_DOCUMENTS_ID_HEADER = "ID";
export const ALL_DOCUMENTS_TYPE_HEADER = "Type";
export const ALL_DOCUMENTS_ATTACHMENT_HEADER = "Attachment";
export const ALL_DOCUMENTS_BY_HEADER = "By";
export const ALL_DOCUMENTS_DATE_FIELD = "sortDate";
export const ALL_DOCUMENTS_ID_FIELD = "displayId";
export const ALL_DOCUMENTS_DOC_TYPE_FIELD = "docType";
export const ALL_DOCUMENTS_BY_FIELD = "by";

//Enhanced Search
export const DATE_TO_VIEW_LABEL = 'Date to View: ';
export const DATE_TO_VIEW_NAME = 'dateToView';
export const SEARCH_BUTTON_LABEL = 'Search';
export const RETURN_TO_SEARCH_TEXT = 'Return to Search';
export const RETURN_TO_RESULTS_TEXT = 'Return to Results';
export const SEARCH_STB_RECORDS_TEXT = 'Search STB Records';
export const MAILING_LABELS_TEXT = 'Mailing Labels';
export const RETURN_TO_SERVICE_LISTS_TEXT = 'Return to Service Lists';
export const SEARCH_FOR_LABEL = 'Search For: ';
export const SEARCH_FOR_TITLE = 'Search For';
export const SEARCH_FOR_NAME = 'searchFor';
export const LABEL_NAME = 'label';
export const REFINE_RESULTS = 'Refine results';
export const LATE_RELEASE_FIELD = 'isDecisionLate';

//FORMS
export const CONFIRMATION_NUM_LABEL = 'Confirmation Number:';
export const CONFIRMATION_NUM_FIELD = 'confirmationNumber';
export const FILING_FEE_LABEL = 'Select the appropriate';
export const FEE_OPTION_FIELD = 'feeOption';
export const ATTACHMENT_FIELD = 'attachment';
export const REMOVE_ATTACHMENT_FIELD = 'remove-attachment';
export const FILE_FIELD = 'file';
export const PUBLIC_LABEL = 'Public';
export const CONFIDENTIAL_LABEL = 'Confidential';
export const IS_PUBLIC_FIELD = 'isPublic';
export const PARTY_LABEL = 'Party';
export const ADDITIONAL_PARTY_LABEL = 'Additional Party';
export const COMPANY_FIELD = 'company';
export const COMPANY_LABEL = 'Firm/Company:';
export const COMPANY_NAME_LABEL = 'Company Name:';
export const COMPANY_LABEL_2 = 'Company:';
export const JOB_TITLE_FIELD = 'jobTitle';
export const JOB_TITLE_LABEL = 'Job Title:';
export const ADDRESS_ONE_FIELD = 'address1';
export const ADDRESS_ONE_LABEL = 'Address Line 1:';
export const ADDRESS_TWO_FIELD = 'address2';
export const ADDRESS_TWO_LABEL = 'Address Line 2:';
export const CITY_LABEL = 'City:';
export const CITY_FIELD = 'city';
export const STATE_FIELD = 'state';
export const STATE_LABEL = 'State/Province:';
export const ZIP_FIELD = 'zip';
export const ZIP_LABEL = 'Zip/Postal Code:';
export const COUNTRY_FIELD = 'country';
export const COUNTRY_LABEL = 'Country:';
export const PHONE_FIELD = 'phone';
export const PHONE_LABEL = 'Phone Number:';
export const FAX_FIELD = 'fax';
export const FAX_LABEL = 'Fax Number:';
export const DOCKET_NUMBERS_FIELD = 'docketNumbers';
export const DOCKET_PREFIX_FIELD = 'docketPrefix';
export const DOCKET_SUFFIX_FIELD = 'docketSuffix';
export const SEQUENCE_NUM_FIELD = 'sequenceNumber';
export const SUBSEQUENCE_NUM_FIELD = 'subSequenceNumber';
export const GENERAL_FILING_TYPE_FIELD = 'generalFilingType';
export const RECORDATION_WATER_RAIL_FIELD = "recordationWaterOrRail";
export const RECORDATION_WATER_RAIL_LABEL = "Is this a Water or Rail Recordation?";
export const RECORDATION_WATER_RAIL_OPTIONS = [
	{label: "Water", value: "water"},
	{label: "Rail", value: "rail"}
];
export const RECORDATION_OPTION_FIELD = "recordationOption";
export const RECORDATION_OPTION_LABEL = "Is this a primary or secondary recordation?";
export const RECORDATION_OPTIONS = [
	{ label: "Primary", value: "Primary" },
	{ label: "Secondary", value: "Secondary" }
];

export const ISSUE_FIELD = 'issue';
export const ISSUE_LABEL = 'Issue:';
export const COMMODITY_GROUP_FIELD = 'commodityGroup';
export const COMMODITY_GROUP_LABEL = 'Commodity Group:';
export const REGION_FIELD = 'region';
export const REGION_LABEL = 'Region:';
export const RAILROADS_INVOLVED_FIELD = 'railroadsInvolved';
export const RAILROADS_INVOLVED_LABEL = 'Railroads Involved:';
export const PROBLEM_LOCATION_FIELD = 'problemLocation';
export const PROBLEM_LOCATION_LABEL = 'Problem Location:';
export const INDUSTRY_LOCATION_FIELD = 'industryLocation';
export const INDUSTRY_LOCATION_LABEL = 'Industry Location:';
export const PROBLEM_DATES_FIELD = 'problemDates';
export const PROBLEM_DATES_LABEL = 'Problem Dates:';
export const ISSUE_SUMMARY_FIELD = 'issueSummary';
export const ISSUE_SUMMARY_LABEL = 'Summary of Issue:';
export const CONTACT_PERMISSION_FIELD = 'contactPermission';
export const CONTACT_PERMISSION_LABEL = 'May we contact the rail carrier(s) on your behalf as part of our effort to resolve the issue?';
export const EFILING_SUBMIT_CHECKBOX_FIELD = "eFilingSubmitCheckbox";

// Fields which should be HTML Decoded
export const ENHANCED_SEARCH_TEXT_FIELDS = [
	DOCUMENT_NAME_FIELD,
	DOCKET_TITLE_FIELD,
	DECISION_TYPE_FIELD,
	DECIDING_BODY_FIELD,
	DECISION_SUMMARY_FIELD,
	FILING_TYPE_FIELD,
	FILING_ID_FIELD,
	FILED_FOR_FIELD,
	RECORDATION_WATER_RAIL_FIELD,
	RECORDATION_CATEGORY_FIELD,
	RECORDATION_PARTY_FIELD,
	RECORDATION_TYPE_OF_AGREEMENT_FIELD,
	RECORDATION_EQUIPMENT_DESCRIPTION_FIELD,
	PARTY_TYPE_FIELD,
	FILED_BY_FIELD,
	SUBMITTER_FIELD,
	COMPANY_FIELD,
	ADDRESS_ONE_FIELD,
	ADDRESS_TWO_FIELD,
	ADDRESS_CITY_FIELD,
	ADDRESS_STATE_FIELD,
	ADDRESS_ZIP_FIELD,
	ADDRESS_COUNTRY_FIELD,
	ADDRESS_TEL_FIELD,
	ADDRESS_FAX_FIELD,
	EMAIL_FIELD,
	ENVCOM_SUBMITTER_OR_RECIPIENT_FIELD,
	ENVCOM_ORGANIZATION_FIELD,
	ENVCOM_COMMENTS_FIELD,
	ENVCOM_RECIPIENT_FIELD,
	ALL_DOCUMENTS_BY_FIELD,
	ATTACHMENT_FIELD
];

//ADVANCED SEARCH
export const DOCUMENT_TEXT_SEARCH_LABEL = "Document Text Search";
export const DOCUMENT_TEXT_SEARCH_ALL_LABEL = "All of these words:";
export const DOCUMENT_TEXT_SEARCH_ALL_NAME = "documentSearchAll";
export const DOCUMENT_TEXT_SEARCH_EXACT_LABEL = "This exact phrase:";
export const DOCUMENT_TEXT_SEARCH_EXACT_NAME = "documentSearchExact";
export const DOCUMENT_TEXT_SEARCH_ANY_LABEL = "Any of these words:";
export const DOCUMENT_TEXT_SEARCH_ANY_NAME = "documentSearchAny";
export const DOCUMENT_TEXT_SEARCH_NONE_LABEL = "None of these words:";
export const DOCUMENT_TEXT_SEARCH_NONE_NAME = "documentSearchNone";

export const DOCKET_NUM_FIELDS = [
	DOCKET_PREFIX_FIELD,
	SEQUENCE_NUM_FIELD,
	SUBSEQUENCE_NUM_FIELD,
	DOCKET_SUFFIX_FIELD
];

export const DATE_FIELDS = [
	SERVICE_DATE_START_NAME,
	SERVICE_DATE_END_NAME,
	FILING_DATE_START_NAME,
	FILING_DATE_END_NAME,
	DATE_TO_VIEW_NAME,
	ENVCOM_DATE_START_NAME,
	ENVCOM_DATE_END_NAME
];

export const PARTY_FIELDS = [
	FILED_FOR_FIELD,
	FILED_BY_FIELD,
	PARTY_TYPE_FIELD,
	OTHER_PARTY_TYPE_FIELD,
	COMPANY_FIELD,
	ADDRESS_ONE_FIELD,
	ADDRESS_TWO_FIELD,
	CITY_FIELD,
	STATE_FIELD,
	ZIP_FIELD,
	COUNTRY_FIELD,
	PHONE_FIELD,
	FAX_FIELD,
	EMAIL_FIELD,
	ADDITIONAL_EMAIL_FIELD
];

export const PARTY_FIELDS_REQUIRED = {
	[FORMAL_FILING_FORM_TYPE]: [
		FILED_FOR_FIELD,
		FILED_BY_FIELD,
		COMPANY_FIELD,
		ADDRESS_ONE_FIELD,
		CITY_FIELD,
		STATE_FIELD,
		ZIP_FIELD,
		COUNTRY_FIELD,
		PHONE_FIELD,
		EMAIL_FIELD,
		ADDITIONAL_EMAIL_FIELD
	],
	[OTHER_FILING_FORM_TYPE]: [
		FILED_FOR_FIELD,
		FILED_BY_FIELD,
		COMPANY_FIELD,
		ADDRESS_ONE_FIELD,
		CITY_FIELD,
		STATE_FIELD,
		ZIP_FIELD,
		COUNTRY_FIELD,
		PHONE_FIELD,
		EMAIL_FIELD,
		ADDITIONAL_EMAIL_FIELD
	],
	[RECORDATION_FORM_TYPE]: [
		PARTY_TYPE_FIELD,
		COMPANY_FIELD,
		ADDRESS_ONE_FIELD,
		CITY_FIELD,
		STATE_FIELD,
		ZIP_FIELD,
		COUNTRY_FIELD
	]
};

export const RESULT_HEADERS = {
	decision: [
		SERVICE_DATE_HEADER,
		DECISION_ID_HEADER,
		DOCKET_NUM_HEADER,
		DOCKET_TITLE_HEADER,
		DECISION_TYPE_HEADER,
		DECIDING_BODY_HEADER,
		DECISION_SUMMARY_HEADER,
		DECISION_ATTACHMENT_HEADER
	],
	filing: [
		OFFICIAL_FILING_DATE_HEADER,
		DOCKET_NUM_HEADER,
		FILING_ID_HEADER,
		FILED_FOR_HEADER,
		FILING_TYPE_HEADER,
		DOCKET_TITLE_HEADER,
		FILING_ATTACHMENT_HEADER
	],
	docket: [DOCKET_NUM_HEADER, DOCKET_TITLE_HEADER, SERVICE_LIST_HEADER],
	recordation: [
		OFFICIAL_FILING_DATE_HEADER,
		RECORDATION_NO_HEADER,
		RECORDATION_TYPE_OF_AGREEMENT_HEADER,
		RECORDATION_HAC_HEADER,
		RECORDATION_EQUIPMENT_DESCRIPTION_HEADER,
		RECORDATION_PARTY_HEADER,
		FILING_ATTACHMENT_HEADER
	],
	serviceList: [
		PARTY_TYPE_HEADER,
		FILED_BY_HEADER,
		ADDRESS_HEADER,
		EMAILS_TEXT,
		FILED_FOR_HEADER
	],
	environmentalComment: [
		ENVCOM_DATE_HEADER,//Date
		ENVCOM_ID_HEADER,//ID
		DOCKET_NUM_HEADER,//Docket Number
		ENVCOM_SUBMITTER_OR_RECIPIENT_HEADER,//Submitter or Recipient
		ENVCOM_ORGANIZATION_HEADER,//Organization
		ENVCOM_COMMENTS_HEADER,//Environmental Comments
		ENVCOM_LOCATION_HEADER,//Location
		ENVCOM_ATTACHMENT_HEADER//Attachment
	],
	document: [
		ALL_DOOCUMENTS_DATE_HEADER,
		ALL_DOCUMENTS_ID_HEADER,
		ALL_DOCUMENTS_TYPE_HEADER,
		DOCKET_NUM_HEADER,
		DOCKET_TITLE_HEADER,
		ALL_DOCUMENTS_BY_HEADER,
		DECISION_SUMMARY_HEADER,
		ALL_DOCUMENTS_ATTACHMENT_HEADER
	]
};

export const BY_DATE_RESULT_HEADERS = {
	decision: [
		DECISION_ID_HEADER,
		DOCKET_NUM_HEADER,
		DOCKET_TITLE_HEADER,
		DECISION_TYPE_HEADER,
		DECIDING_BODY_HEADER,
		DECISION_SUMMARY_HEADER,
		DECISION_ATTACHMENT_HEADER
	],
	filing: [
		DOCKET_NUM_HEADER,
		FILING_ID_HEADER,
		FILED_FOR_HEADER,
		FILING_TYPE_HEADER,
		DOCKET_TITLE_HEADER,
		FILING_ATTACHMENT_HEADER
	],
	recordation: [
		OFFICIAL_FILING_DATE_HEADER,
		RECORDATION_NO_HEADER,
		RECORDATION_TYPE_OF_AGREEMENT_HEADER,
		RECORDATION_HAC_HEADER,
		RECORDATION_EQUIPMENT_DESCRIPTION_HEADER,
		RECORDATION_PARTY_HEADER,
		RECORDATION_CROSS_REFERENCE_HEADER,
		FILING_ATTACHMENT_HEADER
	],
	environmentalComment: [
		ENVCOM_DATE_HEADER,//Date
		ENVCOM_ID_HEADER,//ID
		DOCKET_NUM_HEADER,//Docket Number
		ENVCOM_SUBMITTER_OR_RECIPIENT_HEADER,//Submitter or Recipient
		ENVCOM_ORGANIZATION_HEADER,//Organization
		ENVCOM_COMMENTS_HEADER,//Environmental Comments
		ENVCOM_LOCATION_HEADER,//Location
		ENVCOM_ATTACHMENT_HEADER//Attachment
	]
};

export const RESULT_FIELDS = {
	decision: [
		SERVICE_DATE_FIELD,
		DECISION_ID_FIELD,
		DOCKET_NUM_FIELD,
		DOCKET_TITLE_FIELD,
		DECISION_TYPE_FIELD,
		DECIDING_BODY_FIELD,
		DECISION_SUMMARY_FIELD,
		DECISION_ATTACHMENT_FIELD
	],
	filing: [
		FILING_DATE_FIELD,
		DOCKET_NUM_FIELD,
		FILING_ID_FIELD,
		FILED_FOR_FIELD,
		FILING_TYPE_FIELD,
		DOCKET_TITLE_FIELD,
		FILING_ATTACHMENT_FIELD
	],
	docket: [
		DOCKET_NUM_FIELD,
		DOCKET_TITLE_FIELD,
		SERVICE_LIST_FIELD
	],
	recordation: [
		OFFICIAL_FILING_DATE_FIELD,
		RECORDATION_NUM_FIELD,
		RECORDATION_TYPE_OF_AGREEMENT_FIELD,
		RECORDATION_HAC_FIELD,
		RECORDATION_EQUIPMENT_DESCRIPTION_FIELD,
		RECORDATION_PARTY_NAME,
		DOCUMENT_NAME_FIELD
	],
	serviceList: [
		PARTY_TYPE_FIELD,
		FILED_BY_FIELD,
		ADDRESS_FIELD,
		EMAIL_FIELD,
		FILED_FOR_FIELD
	],
	environmentalComment: [
		ENVCOM_DATE_FIELD,//Date
		ENVCOM_ID_FIELD,//ID
		DOCKET_NUM_FIELD,//Docket Number
		ENVCOM_SUBMITTER_OR_RECIPIENT_FIELD,//Submitter or Recipient
		ENVCOM_ORGANIZATION_FIELD,//Organization
		ENVCOM_COMMENTS_FIELD,//Environmental Comments
		ENVCOM_LOCATION_FIELD,//Location
		ENVCOM_ATTACHMENT_FIELD//Attachment
	],
	document: [
		ALL_DOCUMENTS_DATE_FIELD,
		ALL_DOCUMENTS_ID_FIELD,
		ALL_DOCUMENTS_DOC_TYPE_FIELD,
		DOCKET_NUM_FIELD,
		DOCKET_TITLE_FIELD,
		ALL_DOCUMENTS_BY_FIELD,
		DECISION_SUMMARY_FIELD,
		ATTACHMENT_FIELD
	]
};

export const BY_DATE_RESULT_FIELDS = {
	decision: [
		DECISION_ID_FIELD,
		DOCKET_NUM_FIELD,
		DOCKET_TITLE_FIELD,
		DECISION_TYPE_FIELD,
		DECIDING_BODY_FIELD,
		DECISION_SUMMARY_FIELD,
		DECISION_ATTACHMENT_FIELD
	],
	filing: [
		DOCKET_NUM_FIELD,
		FILING_ID_FIELD,
		FILED_FOR_FIELD,
		FILING_TYPE_FIELD,
		DOCKET_TITLE_FIELD,
		FILING_ATTACHMENT_FIELD
	],
	recordation: [
		OFFICIAL_FILING_DATE_FIELD,
		RECORDATION_NUM_FIELD,
		RECORDATION_TYPE_OF_AGREEMENT_FIELD,
		RECORDATION_HAC_FIELD,
		RECORDATION_EQUIPMENT_DESCRIPTION_FIELD,
		RECORDATION_PARTY_NAME,
		RECORDATION_CROSS_REFERENCE_NUMBERS,
		RECORDATION_ATTACHMENT_FIELD
	],
	environmentalComment: [
		ENVCOM_DATE_FIELD,//Date
		ENVCOM_ID_FIELD,//ID
		DOCKET_NUM_FIELD,//Docket Number
		ENVCOM_SUBMITTER_OR_RECIPIENT_FIELD,//Submitter or Recipient
		ENVCOM_ORGANIZATION_FIELD,//Organization
		ENVCOM_COMMENTS_FIELD,//Environmental Comments
		ENVCOM_LOCATION_FIELD,//Location
		ENVCOM_ATTACHMENT_FIELD//Attachment
	]
};

export const DOCUMENT_TEXT_SEARCH_NAMES = [
	DOCUMENT_TEXT_SEARCH_ALL_NAME,
	DOCUMENT_TEXT_SEARCH_ANY_NAME,
	DOCUMENT_TEXT_SEARCH_EXACT_NAME,
	DOCUMENT_TEXT_SEARCH_NONE_NAME
];

export const CENTERED_RESULT_COLUMNS = [
	SERVICE_DATE_FIELD,
	DECISION_ID_FIELD,
	DECISION_ATTACHMENT_FIELD,
	FILING_DATE_FIELD,
	FILING_ID_FIELD,
	FILING_ATTACHMENT_FIELD,
	SERVICE_DATE_HEADER,
	DECISION_ID_HEADER,
	DOCKET_NUM_HEADER,
	OFFICIAL_FILING_DATE_HEADER,
	DOCKET_NUM_HEADER,
	FILING_ID_HEADER,
	SERVICE_LIST_HEADER,
	DECISION_TYPE_HEADER,
	DECIDING_BODY_HEADER,
	RECORDATION_NO_HEADER,
	RECORDATION_HAC_HEADER
];

export const BY_DATE_LABELS = [
	DECISIONS_SEARCH_FOR_OPTION,
	FILINGS_SEARCH_FOR_OPTION,
	RAIL_RECORDATIONS_SEARCH_FOR_OPTION,
	WATER_RECORDATIONS_SEARCH_FOR_OPTION,
	ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION
];

export const DOCKET_ASSOCIATED_LABELS = [
	ALL_DOCUMENTS_SEARCH_FOR_OPTION,
	`${ASSOCIATED_TAB_LABEL} ${DECISIONS_SEARCH_FOR_OPTION}`,
	`${ASSOCIATED_TAB_LABEL} ${FILINGS_SEARCH_FOR_OPTION}`,
	ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION
];

export const ALL_DOCUMENTS_DECISION_RED_TEXT_FIELDS = [
	ALL_DOCUMENTS_DATE_FIELD,
	ALL_DOCUMENTS_ID_FIELD,
	ALL_DOCUMENTS_DOC_TYPE_FIELD,
	DOCKET_NUM_FIELD,
	DOCKET_TITLE_FIELD,
	ALL_DOCUMENTS_BY_FIELD
];
